module.exports = __webpack_public_path__ + "img/_DSC6726.3c651cb0.jpg";